var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dapp-mobile-navigation-button cursor-pointer",on:{"click":function($event){return _vm.$emit('menu-toggle', !_vm.isOpen)}}},[_c('img',{attrs:{"src":_vm.getImageUrl(_vm.iconPath),"alt":"Menu"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }